var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import moment from 'moment';
import FieldWrap from '../FieldWrap/FieldWrap';
import MomentInput from 'react-moment-input';

var FieldComponent = function FieldComponent(_ref) {
  var input = _ref.input,
      meta = _ref.meta,
      displayNotes = _ref.displayNotes,
      restrictions = _ref.restrictions;
  var dateOptions = {};

  if (restrictions && restrictions.find(function (r) {
    return r.validationName.toLowerCase() === 'past date';
  })) {
    dateOptions.max = moment().format('DD/MM/YY');
  }

  var previousValue = moment(input.value, 'DD/MM/YY');

  if (previousValue !== 'Invalid date') {
    dateOptions.value = previousValue;
  }

  var handleChange = function handleChange(date) {
    if (moment(date) != 'Invalid date') {
      input.onChange(date);
    }
  };

  return React.createElement(FieldWrap, {
    meta: meta,
    displayNotes: displayNotes
  }, React.createElement(MomentInput, _extends({}, dateOptions, {
    format: 'DD/MM/YY',
    options: true,
    readOnly: false,
    icon: false,
    onChange: function onChange(date) {
      return date && date._i && handleChange(date._i);
    }
  })));
};

var DateComponent = function DateComponent(_ref2) {
  var name = _ref2.name,
      label = _ref2.label,
      displayNotes = _ref2.displayNotes,
      validate = _ref2.validate,
      restrictions = _ref2.restrictions;
  return React.createElement('div', {
    className: 'form-group'
  }, React.createElement('label', null, label), React.createElement(Field, {
    name: name,
    validate: validate,
    restrictions: restrictions,
    displayNotes: displayNotes,
    component: FieldComponent
  }));
};

DateComponent.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.element.isRequired,
  displayNotes: PropTypes.string,
  validate: PropTypes.array,
  restrictions: PropTypes.array
};
DateComponent.defaultProps = {
  validate: []
};
export default DateComponent;